import Vue from 'vue'
import Router from 'vue-router'

import {redireccionLogin} from './helpers/api'

const privateRoutes = (() => {
	const manifest = process.env.VUE_APP_MANIFEST
	if (manifest === 'atunsacompras') return require('./router/privateRoutes.atunsacompras').default
	if (manifest === 'stage') return require('./router/privateRoutes.stage').default
	if (manifest === 'sga') return require('./router/privateRoutes.sga').default
	return require('./router/privateRoutes.empty').default
})()

Vue.use(Router)

const router = new Router({
	//mode: 'history',
	base: process.env.BASE_URL,
	routes: [{
			path: '/',
			name: 'inicio',
            component: () => import( /* webpackChunkName: "inicio" */ './views/Inicio.vue')
		}, {
			path: '/maintenance',
			name: 'maintenance',
		   component: () => import( /* webpackChunkName: "maintenance" */ './views/Maintenance.vue')
	   	}, {
		 	path: '/login',
		 	name: 'login',
            component: () => import( /* webpackChunkName: "login" */ './views/Login.vue')
		}, {
			path: '/share',
			name: 'share',
            component: () => import( /* webpackChunkName: "share" */ './views/Share.vue')
		}, {
			path: '/profile',
			name: 'profile',
			component: () => import( /* webpackChunkName: "profile" */ './views/Profile.vue')
		},
		...privateRoutes,
		{
			path: '/:entidad',
			name: 'entidad',
			props: true,
			component: () => import( /* webpackChunkName: "entidad" */ './views/Entidad.vue')
		}, {
			path: '/:entidad/:id',
			name: 'detail',
			props: true,
			component: () => import( /* webpackChunkName: "detail" */ './views/Detail.vue')
		}, {
			path: '/:entidad/:propiedad/:id',
			name: 'dmsdriveentidadid',
			props: true,
			component: () => import( /* webpackChunkName: "dmsdriveentidad" */ './views/Entidad.vue')
		}, {
			path: '/:entidad/:propiedad',
			name: 'dmsdriveentidad',
			props: true,
			component: () => import( /* webpackChunkName: "dmsdriveentidad" */ './views/Entidad.vue')
		}, {
            path: '*',
            component: () => import( /* webpackChunkName: "PageNotFound" */ './views/PageNotFound.vue')
        }
	]
})

router.beforeEach((to, from, next) => {
	const publicRoutes = ['login','share']
	const tokenExist = localStorage.getItem('accessToken_appficha')
	const config = require('../public/config.json')
	
	if (config.maintenance) {

		if  (to.name == 'maintenance') {
			next()
		} else {
			next('/maintenance')
		}

	} else {
		console.log('toname', to)
		if (publicRoutes.includes(to.name)) {
	
			if(to.name == 'login' && tokenExist) {
				next('/')
			} else {
				next()
			}
			
		}
		else if (tokenExist) {
	
			next()
	
		}
		else {
			
			if (config.externallogin) {
				redireccionLogin()
			} else {

				if (to.path.includes('compartir')) localStorage.setItem('redirect', to.path)

				// window.location.href = `${window.location.origin}/#/login${window.location.search || ''}`

				next(`/login${window.location.search || ''}`)
			}
	
		}
	}

})

export default router

